import type { ReactNode } from "react";
import { useWidgetConfig } from "../../customization/hooks/use-widget-config";
import { ExternalWalletProvider } from "./external-wallet-provider";
import { InternalWalletProvider } from "./internal-wallet-provider";

interface WalletProviderProps {
  children: ReactNode;
}

export function WalletProvider({ children }: WalletProviderProps) {
  const { features, config } = useWidgetConfig();
  const isWidgetOnly = config.customerId !== "demo";

  // If not widget-only (demo mode), always use the internal wallet provider
  if (!isWidgetOnly) {
    return <InternalWalletProvider>{children}</InternalWalletProvider>;
  }

  if (features.walletMode === "external") {
    return <ExternalWalletProvider>{children}</ExternalWalletProvider>;
  }

  return <InternalWalletProvider>{children}</InternalWalletProvider>;
}
